import { motion } from 'framer-motion';
import { Phone, CheckCircle2 } from 'lucide-react';
import { PRICING } from '@/constants/testIds';

const IMG =
	'https://images.pexels.com/photos/6140995/pexels-photo-6140995.jpeg';

const POINTS = [
	'No hidden fees. Ever.',
	'Free quote by phone before we roll.',
	'Transparent per-service pricing.',
	'Cash, card and mobile pay accepted.',
];

export const Pricing = () => {
	return (
		<section
			data-testid={PRICING.root}
			className="bg-brand-navy text-white overflow-hidden"
		>
			<div className="mx-auto max-w-[1400px] grid grid-cols-1 lg:grid-cols-12 min-h-[560px]">
				{/* Image column with spotlight framing */}
				<div className="relative lg:col-span-5 min-h-[320px] lg:min-h-full border-r border-white/15 overflow-hidden">
					<motion.img
						initial={{ scale: 1.15 }}
						whileInView={{ scale: 1 }}
						viewport={{ once: true, margin: '-100px' }}
						transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
						src={IMG}
						alt="Roadside inspection at dusk"
						className="absolute inset-0 w-full h-full object-cover"
					/>
					<div
						aria-hidden
						className="absolute inset-0 bg-brand-navy/50"
					/>
					<div
						aria-hidden
						className="absolute inset-0"
						style={{
							background:
								'radial-gradient(circle at 30% 30%, transparent 0%, rgba(13,27,42,0.85) 65%)',
						}}
					/>
					<div className="absolute top-4 left-4 sm:top-6 sm:left-6 flex items-center gap-2 font-chivo text-[10px] uppercase tracking-[0.3em] font-bold text-white/70">
						<span className="w-2 h-2 bg-brand-red pulse-dot" />
						On-scene · Live
					</div>
					<div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 font-anton text-3xl sm:text-4xl leading-none">
						No surprises.
						<br />
						<span className="text-brand-red">Just service.</span>
					</div>
				</div>

				{/* Copy column */}
				<div className="lg:col-span-7 px-6 sm:px-12 py-16 sm:py-24 flex flex-col justify-center">
					<div className="font-chivo text-xs uppercase tracking-[0.3em] text-brand-red font-bold mb-6">
						/ Pricing Transparency
					</div>

					<motion.h2
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.7 }}
						className="font-anton text-[38px] sm:text-[56px] md:text-[68px] leading-[0.95]"
					>
						You’ll know the price{' '}
						<span className="text-brand-red">before we drive.</span>
					</motion.h2>

					<ul className="mt-10 space-y-4 max-w-xl">
						{POINTS.map((p, i) => (
							<motion.li
								key={p}
								initial={{ opacity: 0, x: -20 }}
								whileInView={{ opacity: 1, x: 0 }}
								viewport={{ once: true }}
								transition={{ duration: 0.5, delay: i * 0.08 }}
								className="flex items-start gap-4 border-b border-white/15 pb-4"
							>
								<CheckCircle2
									className="w-5 h-5 mt-1 text-brand-red flex-shrink-0"
									strokeWidth={2}
								/>
								<span className="font-chivo font-bold text-lg sm:text-xl">
									{p}
								</span>
							</motion.li>
						))}
					</ul>

					<a
						href="tel:+13072224082"
						data-testid={PRICING.callCta}
						className="btn-red mt-10 self-start text-lg sm:text-xl pulse-ring"
					>
						<Phone className="w-5 h-5" strokeWidth={2.5} />
						Get a free quote — (307) 222-4082
					</a>
				</div>
			</div>
		</section>
	);
};

export default Pricing;
